import { createAsyncThunk } from '@reduxjs/toolkit'
import featureFlagsService from 'services/feature-flags/feature-flags.service'

export const getFeatureFlags = createAsyncThunk(
	'flags/get-feature-flags',
	featureFlagsService.getFeaturedFlags
)
